import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { initPixel } from "@/lib/fbpixel";

// Define the Meta Pixel before render; the router fires PageView per route.
initPixel();

// ⚠️ READ lib/queryKeys.js BEFORE WRITING THE FIRST useQuery IN THIS APP.
//
// Every data endpoint we have is scoped server-side to the session's active
// workspace, and `staleTime: 60_000` means a cache hit answers without asking
// the server. So a key that does not name the workspace — `["brands"]` — will
// serve workspace A's response to workspace B for up to a minute after a
// switch. Backend isolation cannot save you; the request is never made.
//
// Use `wsKey(workspaceId, ...)` from lib/queryKeys.js for anything
// workspace-scoped, with `enabled: !!workspaceId`. There is currently no
// useQuery in the app — this comment exists so the first one is correct.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
